/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Statusrevokesuccess3Inputs */

const en_usermanagement_permissions_statusrevokesuccess3 = /** @type {(inputs: Usermanagement_Permissions_Statusrevokesuccess3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role revoked successfully`)
};

/**
* | output |
* | --- |
* | "Role revoked successfully" |
*
* @param {Usermanagement_Permissions_Statusrevokesuccess3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_statusrevokesuccess3 = /** @type {((inputs?: Usermanagement_Permissions_Statusrevokesuccess3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Statusrevokesuccess3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_statusrevokesuccess3(inputs)
});
export { usermanagement_permissions_statusrevokesuccess3 as "userManagement_permissions_statusRevokeSuccess" }